export default __webpack_public_path__ + "static/media/logo-swisstraffic.985d2e86.svg";